"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const axiosClient_1 = require("../../api/axiosClient");
const config = {
    headers: {
        'Content-Type': 'application/json',
    },
};
const UISettingsAPI = {
    makeBaseURI(clusterId) {
        return `/v2/clusters/${clusterId ? clusterId : ''}/ui-settings`;
    },
    get(clusterId) {
        return axiosClient_1.clientWithoutCaseConverter.get(UISettingsAPI.makeBaseURI(clusterId));
    },
    put(clusterId, data) {
        return axiosClient_1.clientWithoutCaseConverter.put(UISettingsAPI.makeBaseURI(clusterId), data, config);
    },
};
exports.default = UISettingsAPI;
//# sourceMappingURL=UISettingsAPI.js.map